import { render, staticRenderFns } from "./PrimaryTrustees.vue?vue&type=template&id=bc663338"
import script from "./PrimaryTrustees.vue?vue&type=script&lang=js"
export * from "./PrimaryTrustees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports